// 同步自 resume-self/resumes/current/resume.tex，资料截止 2026-09-13。
// 词云完整保留原词库；资料来源与证据边界见 docs/ushouldknow-capability-20260913.md。
export const resumeQuickEn = {
    "heroTitle": [
        "Hi, I am R0",
        "Fullstack Leadership."
    ],
    "positioning": "AI product & engineering lead. I connect product judgment, visual design, fullstack engineering, and algorithmic depth with technical strategy and team leadership — from setting direction to building systems that last.",
    "positioningHighlights": [
        "AI product & engineering lead",
        "product judgment",
        "visual design",
        "fullstack engineering",
        "algorithmic depth",
        "technical strategy",
        "team leadership"
    ],
    "skillsTitle": "Skills",
    "skills": [
        "C++",
        "Modern C++",
        "STL",
        "RAII",
        "Golang",
        "Python3",
        "TypeScript",
        "JavaScript",
        "React",
        "Next.js",
        "Vue3",
        "Electron",
        "Node.js",
        "gRPC",
        "WebSocket",
        "FastAPI",
        "Django",
        "Gin",
        "Go-Zero",
        "MySQL",
        "PostgreSQL",
        "MongoDB",
        "Redis",
        "ClickHouse",
        "Elasticsearch",
        "Kafka",
        "RabbitMQ",
        "Docker",
        "Kubernetes",
        "Terraform",
        "Nginx",
        "GitHub Actions",
        "CI/CD",
        "Prometheus",
        "Grafana",
        "OpenTelemetry",
        "Scikit-learn",
        "XGBoost",
        "LightGBM",
        "CatBoost",
        "PyTorch",
        "TensorFlow",
        "Learning to Rank",
        "CTR/CVR Modeling",
        "Sequence Modeling",
        "Graph Embedding",
        "A/B Testing",
        "Causal Inference",
        "Bayesian Optimization",
        "DQN",
        "PPO",
        "MDP",
        "RAG",
        "LangChain",
        "LangGraph",
        "LlamaIndex",
        "FAISS",
        "HNSW",
        "ANN Retrieval",
        "Milvus",
        "Weaviate",
        "Pinecone",
        "OpenAI API",
        "Claude API",
        "Function Calling",
        "Agent Workflow",
        "Prompt Caching",
        "LoRA",
        "PEFT",
        "RLHF",
        "vLLM",
        "ONNX Runtime",
        "LLaMA",
        "Mistral",
        "Qwen",
        "DeepSeek",
        "OpenLLM",
        "ComfyUI",
        "Stable Diffusion",
        "ControlNet",
        "AnimateDiff",
        "NumPy",
        "Pandas",
        "Spark",
        "Flink",
        "Airflow",
        "dbt",
        "Data Governance",
        "Tag Governance",
        "Data Quality",
        "Data Lineage",
        "Feature Engineering",
        "Embedding Retrieval",
        "Multi-Armed Bandit",
        "Uplift Modeling",
        "Pairwise Ranking",
        "Listwise Ranking",
        "LambdaMART",
        "GCN",
        "GraphSAGE",
        "Word2Vec",
        "BERT Embedding",
        "Cold Start Strategy",
        "UCB/Thompson Sampling",
        "Recall@K",
        "NDCG",
        "Dynamic Programming",
        "Graph Algorithms",
        "A* Search",
        "Event Pipeline",
        "Tornado",
        "MobX",
        "Tailwind CSS",
        "RESTful API",
        "Microservices",
        "CQRS",
        "Event Sourcing",
        "JWT",
        "Rust",
        "StarRocks",
        "Paimon",
        "RAGFlow",
        "Agent Harness",
        "MCP-Agent",
        "OpenSearch",
        "Qdrant",
        "Weighted RRF",
        "BGE",
        "RoaringBitmap",
        "WAL",
        "CLIP",
        "MotionCLIP",
        "K-Means",
        "GMM",
        "Arrow"
    ],
    "skillHighlights": [
        "Rust",
        "Golang",
        "Python3",
        "RAG",
        "Agent Harness",
        "Flink",
        "StarRocks",
        "Kafka"
    ],
    "workTitle": "Capability Model",
    "workCate": "Direction. Systems. People. Outcomes.",
    "aboutTitle": "About Me",
    "aboutText": "I think independently and build across disciplines. I care about the whole experience: how a product feels, how its systems work, and how people bring it to life.",
    "aboutHighlights": [
        "think independently",
        "build across disciplines",
        "whole experience"
    ],
    "experienceTitle": "Work & Collaboration",
    "experiences": [
        {
            "company": "Aixera",
            "period": "2026.07 – 2026.09",
            "summary": "Project Technical Lead · project collaboration; technical roadmap, core development, delivery quality, and daily team management.",
            "focus": [
                "Game Factory",
                "Rust / Agent Harness"
            ],
            "progress": 100,
            "face": "(•̀ᴗ•́)و",
            "highlights": []
        },
        {
            "company": "Quanyou · OpenVision group",
            "period": "2025.08 – Present",
            "summary": "Head of AI LAB / Data Development Team Lead · collaboration; AI applications, data platforms, algorithms, and delivery.",
            "focus": [
                "Self-service analytics",
                "Enterprise knowledge",
                "Real-time data"
            ],
            "progress": 100,
            "face": "(=^･ω･^=)",
            "highlights": []
        },
        {
            "company": "Tencent IEG",
            "period": "2022.07 – 2025.08",
            "summary": "Backend Engineer · recommendation and KOL platforms; one of the leading members of the AIGC exploration initiative.",
            "focus": [
                "KOL recommendation",
                "LLM / multimodal systems"
            ],
            "progress": 100,
            "face": "(๑˃̵ᴗ˂̵)",
            "highlights": []
        },
        {
            "company": "MSRA",
            "period": "2021.12 – 2022.06",
            "summary": "Algorithm Researcher · Machine Learning Group, project-based; reinforcement learning and carbon-policy simulation.",
            "focus": [
                "DQN / PPO",
                "Causal inference"
            ],
            "progress": 100,
            "face": "(✧ω✧)",
            "highlights": []
        },
        {
            "company": "DeepRoute.ai",
            "period": "2021.06 – 2021.12",
            "summary": "Software Engineer Intern · autonomous-driving behavior and path planning.",
            "focus": [
                "Rule-based planning",
                "Trajectory optimization"
            ],
            "progress": 100,
            "face": "^_^",
            "highlights": []
        }
    ],
    "contactTitle": "Contact Me",
    "contact": "ushouldknowr0@gmail.com",
    "leadershipResponsibilities": [
        {
            "title": "Product & Business Direction",
            "description": "Turn business needs into product choices and clear measures of value."
        },
        {
            "title": "Technical Strategy & Architecture",
            "description": "Connect product experience, algorithms, and infrastructure; balance capability, cost, and risk."
        },
        {
            "title": "Organization & Team Leadership",
            "description": "Shape responsibilities, develop people, and align teams around shared priorities."
        },
        {
            "title": "Delivery & Operational Governance",
            "description": "Set standards, coordinate delivery, and use evidence to guide continuous improvement."
        }
    ],
    "foundationTitle": "Technical & creative foundation",
    "foundationIntro": "The depth behind the decisions.",
    "foundations": [
        "Art & Visual Design",
        "Frontend & Client",
        "Backend & Infrastructure",
        "Data & Algorithms"
    ],
    "aboutPersonal": "Photographer · Calligrapher (Lingnan School)"
};

export const resumeDetailZh = {
    "subtitle": "AI 产研负责人 / 技术负责人：连接业务目标、技术路线、核心研发与团队交付。",
    "profileFactsTop": [
        "凌瀚远",
        "26 岁",
        "AI 产研负责人 / 技术负责人"
    ],
    "profileFactsBottom": [
        "业务方向与产品规划",
        "技术决策与组织统筹",
        "摄影师",
        "书法家（岭南画派）"
    ],
    "summaryRibbon": [
        {
            "id": "ov",
            "title": "AI LAB / 数据团队负责人",
            "detail": "统筹拳游 AI 应用、数据与算法建设，把关业务优先级、技术路线、资源投入和阶段交付。",
            "stack": "集团背景：敞亮科技（香港，OpenVision）"
        },
        {
            "id": "aixera",
            "title": "Aixera · 项目技术负责人",
            "detail": "负责自然语言游戏生成系统的技术路线、关键研发、交付质量及团队日常管理。",
            "stack": "2026.07–2026.09 · 项目合作"
        },
        {
            "id": "query",
            "title": "智能问数与 Lattice",
            "detail": "10 个审核模板题端到端通过；相关数据能力建设与成本优化每年节省至少 86 万元。",
            "stack": "业务语义 · 受控查询 · 实时数仓"
        },
        {
            "id": "knowledge",
            "title": "企业知识库 · 集团使用",
            "detail": "已接入集团内部全部业务线；评测集扩展至 452 道题，答案正确性 0.825。",
            "stack": "知识编译 · 证据检索 · 权限治理"
        }
    ],
    "sectionTitles": {
        "stack": "技术与工程能力",
        "milestones": "经历与成果",
        "projects": "项目经历"
    },
    "scenes": [
        {
            "id": "boot",
            "points": [
                "腾讯 IEG（2022–2025）",
                "AI LAB / 数据团队（2025–至今）",
                "Aixera（2026.07–2026.09）"
            ]
        }
    ],
    "introExperiences": [
        {
            "company": "深圳市艾塞拉科技有限公司",
            "role": "项目技术负责人（项目合作，兼团队日常管理）",
            "period": "2026.07-2026.09",
            "points": [
                "作为Aixera 自然语言驱动的游戏生成系统的技术负责人，统筹技术路线、核心研发、交付质量与团队日常管理，将产品目标落实为阶段性研发计划。",
                "技术决策与架构：主导游戏生成 Agent 的技术路线与系统架构设计，明确模块职责、协作边界与阶段交付要求，结合生成质量、工程可控性及依赖成本推进方案取舍，并参与关键链路研发。",
                "研发交付与质量把关：牵头关键技术问题攻关，推动模型调用稳定性与异常处理；组织制定规则正确性、游戏可玩性及交互表现的验证标准，统筹回归测试与问题修复，依据运行与评测结果把关阶段交付。",
                "团队统筹与能力建设：统筹产品、研发、测试和运营协作，围绕 MVP 目标明确研发优先级、职责分工与交付边界，协调跨环节依赖并推进阻塞问题解决；通过方案评审与成员辅导，推动团队独立形成判断并承担交付责任。",
                "产品判断与成果沉淀：提出小范围产品验证路径，规划选题、制作、检查、试玩与反馈流程，以验证证据支撑产品方向和研发投入的阶段性取舍；推动技术方案与代表性成果归档，沉淀可复用的生成、评测与交付方法。"
            ],
            "id": "aixera",
            "iconKey": "",
            "iconFallback": "✦",
            "tags": [
                "技术路线与架构",
                "核心研发与质量把关",
                "团队日常管理",
                "跨职能协作",
                "阶段验证与交付"
            ],
            "links": [
                "gamefactory"
            ]
        },
        {
            "company": "广州拳游科技有限公司",
            "role": "AI LAB 部门负责人 / 数据开发团队负责人（合作）",
            "period": "2025.08-至今",
            "points": [
                "统筹 AI LAB 与数据团队，负责 Fantasy 与全球站的 AI 应用、算法及数据能力建设，围绕支付运营、用户经营、研发效率与游戏创新确定优先级，把关技术路线、资源投入与阶段交付。",
                "实时数据与支付监控：牵头实时数据体系建设与多平台接入，组织容量规划、指标口径统一和业务结果对账；推动充提成功率监控、失败原因分析及联运监控在多平台交付，支撑支付异常定位，推进转化预警与风控数据接入。",
                "会员经营与增长数据：统筹 VIP、Cashback、投放成本、用户标签及历史数据建设，组织会员冷启动、降级名单与奖励统计的开发和业务核验；推动会员数据服务上线及奖励规则线上验收，支撑会员权益落地与运营分析。",
                "AI 应用产品化与平台建设：主导 AI LAB 应用规划与产品化推进，围绕业务优先级组织研发资源，统筹产品定义、技术路线与交付验收，推动业务应用和共用能力建设。",
                "研发交付：牵头产研一体 Agent 与“QA 解放计划”试点，覆盖需求理解、代码审查与测试设计。",
                "线上运营：推动日志诊断 Agent 及工具服务生产部署，推进定时推送与预警工作流，重点建设智能问数 Agent。",
                "海外内容：统筹本地化 Agent 业务试用与设计文案工作台验证，覆盖多语言翻译、术语及内容一致性校验。",
                "组织效能：推进招聘评估 Agent 试用及项目知识管理验证，建设企业知识库，支撑“敞亮人”新人赋能。",
                "产品与美术：组织 PRD 与原型工作台、游戏素材与风格工作台验证，支持需求表达、方案展示及创作准备。",
                "AI LAB 基础设施：组织企业知识库与 Agent 开发框架（ADK）建设，完善知识检索、工具接入与开发规范。",
                "AI 游戏孵化与投入判断：组织自然语言到可玩游戏的原型验证，形成覆盖模型、人力与基础设施的一年期投入测算，支持试点范围与资源评审；统筹游戏研发、数值与测试协作，推动玩法、结算和配置问题收敛。",
                "核心算法与工程建设：主导用户分群推荐算法，以行为状态建模支撑差异化推荐，结合风险约束与节奏控制制定策略；组织游戏数值算法设计与验证，推进彩球抽奖、排行榜等后端工程落地，建设可复用的数据与算法服务。",
                "组织建设与交付管理：明确业务研究、研发与效果评估的职责分工，统筹跨部门需求与依赖，推进人才招聘与培养、方案评审和项目验收，建立数据发布与上线核查规范，落实从方案验证到业务应用的交付责任。"
            ],
            "id": "ov",
            "iconKey": "openvision",
            "iconFallback": "✦",
            "tags": [
                "AI LAB 与数据团队统筹",
                "产品定义与技术路线",
                "支付与会员数据交付",
                "Agent 试点与平台建设",
                "招聘培养与上线核查"
            ],
            "links": [
                "query",
                "knowledge",
                "lattice",
                "bilm",
                "ovreco"
            ]
        },
        {
            "company": "深圳市腾讯计算机系统有限公司",
            "role": "IEG互动娱乐事业群，后台研发工程师",
            "period": "2022.07-2025.08",
            "points": [
                "独立研发团队内多个算法项目，如达人智选、达人Feed流推荐、内容风格聚类、内容风险识别和审查系统、基于相对定位的网格OCR识别算法，二游营收能力评估模型、社交网络驱动的多层评分挖掘策略、延迟队列系统等。",
                "2023 AIGC 中台业务探索专项领头成员之一，专项于2022年下旬启动，在早期即开始了对于LLM、LLM with RAG、LLM Chain、Stable-diffusion、CLIP、DragGAN&DragDiffusion、SAM、DINO、Fantasia3D等相关技术的业务落地探索，旨在探索 AIGC 游戏管线的建设方案及论证其合理性。参与项目：星瞳text2motion、星瞳LoRA训练&学车案例渲染管线、基于SAM的“金手指”标注工具、智能客服、基于CLIP的视频检索系统、LLM数据分析管线、Text2SQL模型微调（后成为部门内的“DataGather”工具基座）。",
                "负责“游可爱”项目后端开发，建设全链路多端KOL激励平台，涵盖KOL、内容、MCN、激励任务等多个子系统，支持任务维度与内容维度的全流程管理，覆盖多角色权限与流程管理模块。"
            ],
            "id": "tx",
            "iconKey": "tencent",
            "iconFallback": "✦",
            "tags": [
                "算法项目研发",
                "AIGC 中台探索专项领头成员之一",
                "推荐与内容审查",
                "游可爱 KOL 激励平台"
            ],
            "links": [
                "reco",
                "aipipe",
                "xingtong"
            ]
        },
        {
            "company": "微软亚洲研究院（MSRA）",
            "role": "Machine Learning组，算法研究员，项目制",
            "period": "2021.12-2022.06",
            "points": [
                "参与碳中和政策模拟项目，基于历史能耗、碳排放与经济数据，构建支持政府与企业长期规划的决策智能体系统，目标为模拟碳税、电价、科技投入等政策调控路径的动态反馈与最优解空间。"
            ],
            "id": "msra",
            "iconKey": "msra",
            "iconFallback": "✦",
            "tags": [
                "碳中和政策模拟",
                "强化学习决策智能体",
                "奖励塑形与因果推断"
            ],
            "links": [
                "carbon"
            ]
        },
        {
            "company": "深圳元戎启行科技有限公司",
            "role": "云计算/路径规划，软件开发工程师，实习",
            "period": "2021.06-2021.12",
            "points": [
                "参与 行为规划和路径规划 模块开发，负责编写转弯、变道等场景下的规则逻辑与行为决策逻辑。设计并落地无保护左转、交叉路口协同行驶、环岛通行逻辑、车道变换约束等行为规划规则，结合规则引擎驱动状态机生成可行路径候选。",
                "结合 HD 地图与感知数据（如 LIDAR、摄像头、雷达），定义车辆状态与环境特征输入，优化行为决策逻辑的执行效率与鲁棒性。落地采样与优化技术（A*、采样优化、轨迹优化），参考成本函数设计对路径候选进行排序与评估。"
            ],
            "id": "deeproute",
            "iconKey": "deeproute",
            "iconFallback": "✦",
            "tags": [
                "行为规划与路径规划",
                "规则引擎与状态机",
                "HD Map 与感知融合",
                "A* 与轨迹优化"
            ],
            "links": []
        }
    ],
    "introAchievements": [
        {
            "id": "query",
            "project": "智能问数 Agent：业务自助分析与 Lattice 数仓协同",
            "outcome": "10 个审核模板题端到端通过，标准题口径正确率 ≥90%；相关数据能力建设与成本优化每年节省至少 86 万元。",
            "note": "2026.08-至今 · 【关键词】业务语义、受控查询、确定性工作流、数据复用、自助分析、成本优化",
            "labels": [
                "业务语义",
                "受控查询",
                "确定性工作流",
                "数据复用",
                "自助分析",
                "成本优化"
            ]
        },
        {
            "id": "gamefactory",
            "project": "Game Factory：自然语言驱动的游戏生成 Agent",
            "outcome": "限定玩法样本完成真实模型与生图调用、H5 生成及移动端八态交互验证；状态恢复、动作幂等与运行隔离已有专项验证。",
            "note": "2026.07-2026.09 · 【关键词】Rust、Agent Harness、公平性验证、数值控制、部署治理、多模态、运行隔离",
            "labels": [
                "Rust",
                "Agent Harness",
                "公平性验证",
                "数值控制",
                "部署治理",
                "多模态",
                "运行隔离"
            ]
        },
        {
            "id": "knowledge",
            "project": "企业知识库：知识编译、证据检索与 Agentic 调查",
            "outcome": "已接入集团内部全部业务线使用；评测集扩展至 452 道题，答案正确性 0.825。",
            "note": "2026.06-至今 · 【关键词】RAGFlow、知识编译、业务本体、混合检索、Agentic RAG、权限治理、分层评测",
            "labels": [
                "RAGFlow",
                "知识编译",
                "业务本体",
                "混合检索",
                "Agentic RAG",
                "权限治理",
                "分层评测"
            ]
        },
        {
            "id": "lattice",
            "project": "LatticeFlow 高速数仓：Rust 计算内核与实时数据平台",
            "outcome": "Rust 核心已实现并验证性能提升；实时主链路与业务任务已生产交付，支撑约 1.78 亿条/日源事件规模。",
            "note": "2026.04-至今 · 【关键词】Rust、Arrow、列式批处理、Kafka、Flink、StarRocks、端到端一致性、实时指标",
            "labels": [
                "Rust",
                "Arrow",
                "列式批处理",
                "Kafka",
                "Flink",
                "StarRocks",
                "端到端一致性",
                "实时指标"
            ]
        },
        {
            "id": "bilm",
            "project": "BILM 高性能关系索引与持久化系统（Go）",
            "outcome": "在 largeID 3000 万 / smallID 500 级别完成验证，兼顾内存查询、持久化恢复与成本。",
            "note": "2025.11-2026.02 · 【关键词】RoaringBitmap、WAL、Snapshot、内存数据库",
            "labels": [
                "RoaringBitmap",
                "WAL",
                "Snapshot",
                "内存数据库"
            ]
        },
        {
            "id": "ovreco",
            "project": "全球站推荐：用户节奏感知的受约束收益优化推荐系统",
            "outcome": "以用户分群、状态优先级、多目标排序和风险硬约束支持用户生命周期与节奏保护。",
            "note": "2025.09-至今 · 【关键词】用户分群、行为序列建模、多目标排序、风险感知推荐、生命周期约束、策略编排",
            "labels": [
                "用户分群",
                "行为序列建模",
                "多目标排序",
                "风险感知推荐",
                "生命周期约束",
                "策略编排"
            ]
        },
        {
            "id": "reco",
            "project": "达人智选：多链路召回与社交协同驱动的KOL智能推荐系统",
            "outcome": "召回命中率 ≥85%，Feed 点击率提升 23%，联合推荐覆盖超 30% 任务场景，接入超 20 个游戏项目组。",
            "note": "2024.06-2025.07 · 【关键词】多链路召回、双塔模型、相似度排序、圈层分发、内容聚类、Feed流、社交图、联合推荐",
            "labels": [
                "多链路召回",
                "双塔模型",
                "相似度排序",
                "圈层分发",
                "内容聚类",
                "Feed流",
                "社交图",
                "联合推荐"
            ]
        },
        {
            "id": "aipipe",
            "project": "自动化数据分析管线",
            "outcome": "推理成本下降逾 60%；改造版 NvBench 评估中召回率提升 10.7%，可替代初级分析师工时超 70%。",
            "note": "2023.03-2024.07 · 【关键词】LLM, ToolMaker, LATM, NvBench, Prompt Engineering, 数据安全",
            "labels": [
                "LLM",
                "ToolMaker",
                "LATM",
                "NvBench",
                "Prompt Engineering",
                "数据安全"
            ]
        },
        {
            "id": "xingtong",
            "project": "星瞳 text2motion 动作生成系统",
            "outcome": "支持中英双语，主流动作生成成功率 ≥80%；完成 3 次“直播 3D 回”的 0 bug 运行。",
            "note": "2023.02-2024.07 · 【关键词】LLM, RAG, CLIP, MotionCLIP, Fantasia3D, SAM, 动作生成管线",
            "labels": [
                "LLM",
                "RAG",
                "CLIP",
                "MotionCLIP",
                "Fantasia3D",
                "SAM",
                "动作生成管线"
            ]
        },
        {
            "id": "carbon",
            "project": "基于强化学习的碳中和政策模拟系统",
            "outcome": "模拟环境最优策略：碳排放下降 18%、社会成本降低 12%、策略波动性减少 21%。",
            "note": "2022.02-2022.06 · 【关键词】强化学习、因果推断、政策优化、奖励函数设计、因果图",
            "labels": [
                "强化学习",
                "因果推断",
                "政策优化",
                "奖励函数设计",
                "因果图"
            ]
        }
    ],
    "capabilityTracks": [
        {
            "id": "algoData",
            "name": "算法与实时数据系统",
            "summary": "从业务优先级、资源取舍到实时数据交付。",
            "details": [
                "Rust / Arrow 列式 micro-batch 内核，已实现并验证性能提升",
                "Flink 状态、checkpoint 与 StarRocks 提交的一致性边界",
                "支付状态变更、迟到修正、指标口径与业务窗口一致性",
                "约 1.78 亿条/日源事件；3 平台监控与 10 分钟支付预警"
            ],
            "terms": [
                "Golang",
                "Kafka",
                "MySQL",
                "Flink",
                "StarRocks",
                "Paimon",
                "PostgreSQL",
                "RoaringBitmap",
                "WAL",
                "Rust",
                "Arrow"
            ],
            "value": null
        },
        {
            "id": "fullstack",
            "name": "系统架构与可靠运行",
            "summary": "关注持久化执行、恢复、幂等和可追溯交付。",
            "details": [
                "Rust 控制面与同进程内嵌 Agent Harness",
                "PostgreSQL 状态与事件、租约和 fencing 执行权管理",
                "Worker / OffscreenCanvas 隔离生成代码，服务端结果权威与动作幂等",
                "BILM：RoaringBitmap + Snapshot / Delta / WAL 与增量快照"
            ],
            "terms": [
                "Rust",
                "Golang",
                "PostgreSQL",
                "TypeScript",
                "React",
                "Node.js",
                "gRPC",
                "WebSocket",
                "Docker",
                "Kubernetes",
                "Redis",
                "RoaringBitmap",
                "WAL"
            ],
            "value": null
        },
        {
            "id": "llm",
            "name": "Agent 与企业知识平台",
            "summary": "业务语义、受控工具调用、证据检索与分层评测。",
            "details": [
                "业务语义、任务编排与受控执行分工，按场景确定模型参与及自动化范围",
                "RAGFlow 知识编译、冻结产物、业务本体与多路检索设计",
                "证据组编排、Agentic 调查、权限镜像与可靠性治理",
                "452 道评测题，答案正确性 0.825；保留早期上下文与拒答专项评测"
            ],
            "terms": [
                "Python3",
                "Rust",
                "Agent Harness",
                "RAGFlow",
                "RAG",
                "OpenSearch",
                "Qdrant",
                "Weighted RRF",
                "BGE",
                "LangChain",
                "LlamaIndex",
                "MCP-Agent",
                "CLIP",
                "MotionCLIP",
                "PyTorch"
            ],
            "value": null
        },
        {
            "id": "reco",
            "name": "推荐、数值与算法",
            "summary": "把业务目标转化为可校验的策略和约束。",
            "details": [
                "用户状态分群与 K-Means / GMM 置信校验",
                "六链路召回、社交图联合推荐与多目标排序",
                "Game Factory 多阶段数值校验、公平性验证与部署准入",
                "DQN / PPO 政策模拟、奖励塑形及因果解释"
            ],
            "terms": [
                "Python3",
                "C++",
                "PyTorch",
                "K-Means",
                "GMM",
                "DQN",
                "PPO",
                "Causal Inference",
                "CLIP"
            ],
            "value": null
        }
    ],
    "resumeDomains": [
        {
            "id": "leadership",
            "title": "技术统筹与研发交付",
            "points": [
                "围绕业务目标确定产品范围、技术路线及投入优先级",
                "组织方案评审、跨团队协作、质量验证与项目验收",
                "推进人才招聘、培养及团队独立承担交付责任"
            ]
        },
        {
            "id": "patent",
            "category": "知识产权",
            "title": "专利申请 · 交互式智能图像标注",
            "points": [
                "《图像标注方法、装置、设备及介质》；发明专利申请已公开",
                "唯一发明人：凌瀚远；申请人：腾讯科技（深圳）有限公司",
                "申请号 202311199516.9；申请公布号 CN 117036713 A；申请日 2023.09.15"
            ]
        },
        {
            "id": "copyright",
            "category": "知识产权",
            "title": "软件著作权 · 物联网控制系统",
            "points": [
                "基于机器学习的物联网控制系统；独立著作权人",
                "登记号 2020SR0568084；2020.04",
                "融合多源传感数据与时序预测，实现环境监测、联动控制及告警"
            ]
        },
        {
            "id": "languages",
            "category": "语言",
            "title": "交流语言",
            "points": [
                "粤语、普通话、日语、英语"
            ]
        }
    ],
    "projectHighlights": [
        {
            "title": "智能问数 Agent：业务自助分析与 Lattice 数仓协同",
            "period": "2026.08-至今",
            "keywords": "【关键词】业务语义、受控查询、确定性工作流、数据复用、自助分析、成本优化",
            "desc": "对标数数平台内置 Agent，针对实际试用中业务适配不足、响应耗时长、Token 消耗高的问题，统筹自建问数与 Lattice 数仓协同，协调 Agent 研发、数开及运营数分团队，将高频取数沉淀为可复用、可核验的业务能力。",
            "points": [
                "架构设计与产品策略：主导问数系统的架构设计，明确业务语义、任务编排与受控执行的职责边界；将高频分析需求沉淀为可复用服务，按场景特征确定模型参与及自动化范围，兼顾结果可靠性、响应效率和推理成本，支持业务能力持续扩展和自主迭代。",
                "自助问数与验收成果：将历史查数规则和脚本沉淀为审核模板，10 个模板题端到端验收通过，高频标准题口径正确率不低于 90%；统一统计主体、时区、去重与指标口径，验收范围内越权结果与不合规 SQL 提交均为 0。答案可回溯原问题、语义版本、查询任务及数据截止时间，支持异步查询、历史回看与反馈复核，让业务自助取数有统一口径和核验依据。",
                "数仓协同与数据复用：衔接 Lattice 已有实时指标与数据加工能力，将支付异常、获客漏斗等业务口径沉淀为可复用分析场景；针对大表扫描推动日度聚合、分层复用及回流数数方案，按时效、查询粒度与成本明确数据供给边界，支撑业务自助取数与异常追查。",
                "资源统筹与降本成果：拆分问数、数据加工与平台采购需求，组织现有数仓及任务能力复用，推动自建与采购取舍；相关数据能力建设与成本优化已实现每年节省至少 86 万元，数数平台当前总成本为 180 万元/年。",
                "产品化交付：形成自助查数与推送告警双工作流，支持独立前端、项目切换、结果持久化与飞书投递；复用数据团队的已审核口径与生产任务，连接按需分析和主动异常通知，持续扩展高频场景。"
            ],
            "metric": "10 个审核模板题端到端通过，标准题口径正确率 ≥90%；相关数据能力建设与成本优化每年节省至少 86 万元。",
            "labels": []
        },
        {
            "title": "Game Factory：自然语言驱动的游戏生成 Agent",
            "period": "2026.07-2026.09",
            "keywords": "【关键词】Rust、Agent Harness、公平性验证、数值控制、部署治理、多模态、运行隔离",
            "desc": "构建自然语言驱动的 H5 游戏生成系统，串联意图理解、玩法定义、视觉与交互设计、素材生成和表现代码生成，将开放式创意转化为可执行、可校验的游戏产物。",
            "points": [
                "持久化执行架构：基于 Rust 控制面与同进程内嵌 Agent Harness 实现生成任务调度，通过 PostgreSQL 保存运行状态与事件，结合租约和 fencing 管理执行权；区分排队重领、执行中断与模型传输恢复，限制重试范围，避免重复调用。",
                "规则建模与多阶段数值校验：将校验贯穿定义审阅、投影冻结、生成设计加载及服务端会话创建与恢复；定义阶段核对规则、概率、返还、RTP 与策略及精度约束，后续各环节复验概率分段、固定点尺度、倍率与金额边界，并交叉核对数值来源和版本摘要，逐层拦截非法参数、越界数值与产物不一致。",
                "公平性验证：围绕规则与信息一致性、随机映射偏差、随机消费时序建立验证规范，设计种子承诺、结果揭示与独立重建协议及检查项；明确随机调用与回合、动作的绑定关系，将重试重抽、隐藏结果泄漏和边界歧义纳入检查范围。",
                "多模态表现生成：分离玩法、视觉与交互设计，以冻结设计约束角色图集、海报和场景背景生成；通过素材语义预检与代码合同校验，生成 Canvas2D 场景及 HUD，编译为自包含 H5，统一素材、构图和交互的来源。",
                "服务端结果与运行隔离：由服务端维护私有状态、随机种子与结果计算，浏览器仅提交合法动作并消费已决事件；通过动作回执实现幂等重放与冲突检查，使用 Worker / OffscreenCanvas 和受控 HUD，隔离生成代码的网络、页面与结果决策权限。",
                "部署治理：设计覆盖定义放行、实现验证与部署准入的分阶段治理机制，将规则正确性、数值与公平性验证、产物一致性纳入验收标准；区分阻断性缺陷与待验证事项，明确风险处置及放行条件，建立定义、实现版本、验证报告与交付制品的对应关系，要求变更后重验相关证据，支撑交付决策与过程追溯。",
                "实现与验证：限定玩法样本已完成真实模型与生图调用、H5 产物生成及移动端八态交互验证；服务端状态恢复、动态启动、动作幂等及生成代码网络隔离已有专项验证，形成可追溯的游戏包与运行记录。"
            ],
            "metric": "限定玩法样本完成真实模型与生图调用、H5 生成及移动端八态交互验证；状态恢复、动作幂等与运行隔离已有专项验证。",
            "labels": []
        },
        {
            "title": "企业知识库：知识编译、证据检索与 Agentic 调查",
            "period": "2026.06-至今",
            "keywords": "【关键词】RAGFlow、知识编译、业务本体、混合检索、Agentic RAG、权限治理、分层评测",
            "desc": "面向全员知识使用与团队协作，主导企业知识平台的产品规划与技术路线，覆盖资料管理、证据问答、关系分析与跨资料调查；以有证据支持的任务成功率为核心质量目标，支撑“敞亮人”新人赋能并规划产研 Agent 接入。",
            "points": [
                "平台架构与知识编译：确定 RAGFlow 二次开发与既有服务复用路线，设计 Lark / 本地资料经资产版本管理、结构恢复、冻结切分与语义编译进入检索的链路；保留表头、条件、代码边界与来源定位，预览、索引及引用共用冻结产物，按依赖传播内容、本体与模型变化，减少无效重建。",
                "业务本体与关系图：围绕术语、业务对象、事件证据和治理规则设计语义模型，约束实体消歧、关系方向、有效时间及允许推导；以 PostgreSQL 承载关系投影，设计有界图扩展与路径核验，使关键结论可回查完整支持链。",
                "多路检索与证据编排：设计按问题选择精确、全文、向量、图与原文检索的统一执行层，以 OpenSearch / Qdrant 召回、Weighted RRF 融合和 BGE 重排组织候选；在 token 预算内按新增事实覆盖选择证据组，保留必要前提、关系路径及反证，兼顾去重与回答完整性。",
                "Agentic 调查设计：围绕未决问题与证据缺口编排检索、补读、关系追踪和确定性计算，在授权原文工作区核对复杂表格与历史线索；按证据增益、时延和成本选择后续行动，设置充分性判断、纠正检索、取消与停止规则，证据不足时返回可核验的部分答案。",
                "权限与可靠运行：区分企业登录、来源同步授权与知识消费权限，设计来源权限镜像及受控共享，覆盖派生知识、缓存、引用和历史会话；采用版本复核、撤权优先失效、事务 Outbox、任务租约与幂等恢复，约束异步处理、重试及故障降级。",
                "评测与治理设计：区分来源可答性、上下文充分性与答案正确性，设计从接入、编译、本体到生成与控制的八层诊断；结合业务金标、封闭盲测、消融对照、裁判校准及权限变化测试，按任务成功、引用支持、时延和成本验收，并将冲突与缺口纳入复核、重建和回归。",
                "集团落地与技术验证：已接入集团内部全部业务线使用，支撑业务知识查询、规范检索与新人赋能；评测集扩展至 452 道题，答案正确性达 0.825。早期 54 题内部模型辅助评测中，上下文精确率 0.949、召回率 0.952、答案忠实度 0.877、回答相关性 0.801；既有两轮拒答专项中，每轮 10 道应拒答题均正确拒答，围绕部分可答场景持续完善误拒答控制。"
            ],
            "metric": "已接入集团内部全部业务线使用；评测集扩展至 452 道题，答案正确性 0.825。",
            "labels": []
        },
        {
            "title": "LatticeFlow 高速数仓：Rust 计算内核与实时数据平台",
            "period": "2026.04-至今",
            "keywords": "【关键词】Rust、Arrow、列式批处理、Kafka、Flink、StarRocks、端到端一致性、实时指标",
            "desc": "面向高频业务事件、订单状态变更与实时运营分析，主导高速数仓技术路线与核心计算方案，组织实时采集、流式计算和分析服务落地；以Rust 高性能计算内核为核心优化点，在提升计算效率的同时保持指标口径、状态恢复与事务提交的一致性。",
            "points": [
                "Rust 内核实现与性能验证：实现基于 Arrow 列式数据的 micro-batch 计算，将热路径由逐行处理转为批量执行，摊薄跨语言调用与数据转换开销；按时间、条数和字节量控制批次，兼顾吞吐、延迟与内存峰值，核心 Rust 方案已完成实现并验证性能提升。",
                "计算与状态边界：将 Rust 定位为可替换的确定性执行内核，由 Flink 持有窗口、去重与持久状态并协调恢复；Rust 接收数据批次及所需状态，返回结果与状态变更，将高性能计算纳入同一 checkpoint 边界，约束重放时的结果漂移和跨组件重复提交。",
                "统一链路与一致性设计：以 Kafka 可回放日志连接采集、计算与落仓，统一事件标识、业务时间、Schema 版本及分区键；围绕可重放输入、状态快照和事务／幂等 sink 建立提交契约，结合 StarRocks 主键更新承接结果修正，明确精确指标与异步加速视图的口径边界。",
                "实时指标与迟到修正：组织 MySQL CDC 驱动的支付指标计算与落库，以订单创建时间确定业务窗口，状态变化时撤回旧贡献并重算原窗口，通过 Primary Key upsert 覆盖已输出结果；统一请求、成功、失败及环比口径，避免将迟到更新计入错误时段。",
                "可靠性与容量治理：围绕 checkpoint、消费积压、背压及写入事务建立观测与恢复规范，区分计算耗时与提交可见性延迟；以 DLQ、重试分级和幂等回放约束异常数据处理，并要求与既有业务链路结果对拍。按峰值小时均速约 3,270 条/秒、10 倍容量裕量假设，测算扩展容量目标约 3.3 万条/秒。",
                "数据规模与生产交付：围绕投注、返奖两类源事件约 1.78 亿条/日的规模建设实时处理能力（24 小时统计），主链路及业务任务已上线生产；完成3 个业务平台的近 1 小时提现失败原因监控和10 分钟充值、提现成功率预警，支持定位支付通道与商户异常。",
                "业务验收与湖仓演进：交付 W2A、自裂变 2 类获客漏斗的 10 分钟转化率监控，覆盖浏览、点击、成功注册并完成需求方验收；完成 Paimon 落库及与 StarRocks 联合查询验证，为分层存储与分析能力复用提供依据。"
            ],
            "metric": "Rust 核心已实现并验证性能提升；实时主链路与业务任务已生产交付，支撑约 1.78 亿条/日源事件规模。",
            "labels": []
        },
        {
            "title": "BILM 高性能关系索引与持久化系统（Go）",
            "period": "2025.11-2026.02",
            "keywords": "【关键词】RoaringBitmap、WAL、Snapshot、内存数据库",
            "desc": "设计并实现基础设施级的 BILM（Bitmap-based Inverted Label Matrix）关系索引系统，面向推荐、风控、画像等大规模关联查询场景，兼顾内存查询性能与数据库级可靠性。在大数据量下完成了高性能的二元关系衍生的代数运算功能。",
            "points": [
                "采用 RoaringBitmap 构建主索引结构（smallID → largeID），通过集合包含判断完成反向查询，移除冗余 forward 索引，在不牺牲功能的前提下显著降低内存占用与快照峰值。",
                "构建 Snapshot + Delta + WAL 的多级持久化链路，引入 WAL 先写机制、CRC 校验与原子落盘策略，确保异常中断场景下的数据一致性与可恢复性，对标数据库与 Redis 的可靠性设计思路。",
                "设计基于 Dirty 集合的增量快照机制，结合阈值控制与回退策略，显著降低高频全量快照带来的 CPU / GC 与 I/O 压力，提升系统在高写入负载下的稳定性。",
                "通过锁内一致性切点 + 锁外 I/O 的快照流程优化，减少写路径阻塞时间；在 largeID 3000 万 / smallID 500 级别规模下完成验证，具备明确的成本优势与工程可扩展性。"
            ],
            "metric": "在 largeID 3000 万 / smallID 500 级别完成验证，兼顾内存查询、持久化恢复与成本。",
            "labels": []
        },
        {
            "title": "全球站推荐：用户节奏感知的受约束收益优化推荐系统",
            "period": "2025.09-至今",
            "keywords": "【关键词】用户分群、行为序列建模、多目标排序、风险感知推荐、生命周期约束、策略编排",
            "desc": "构建以用户行为节奏与生命周期保护为核心的推荐系统，打通用户聚合指标、Session 行为序列、状态分群与推荐闭环，在风险可控前提下实现长期收益最大化。",
            "points": [
                "规则主导的用户分群体系：基于资金、行为与状态三维特征定义核心用户标签，引入 K-Means / GMM 对规则分群进行置信度校验，提升分群稳定性与可解释性。",
                "两级用户分群与状态优先级机制：在价值分层基础上建模用户情绪与行为状态（兴奋、追损、挫败、平稳、冷却），通过状态优先级驱动推荐策略切换。",
                "多目标排序与分群感知权重机制：联合建模平台收益、状态匹配度、沉浸度与新颖度，不同用户状态下动态调整排序权重，避免单一 ROI 贪心失控。",
                "显式风险建模与硬约束控制：基于输赢节奏构建风险估计函数，并在高风险状态下执行波动率约束，实现推荐结果的工程可控与节奏保护。"
            ],
            "metric": "以用户分群、状态优先级、多目标排序和风险硬约束支持用户生命周期与节奏保护。",
            "labels": []
        },
        {
            "title": "达人智选：多链路召回与社交协同驱动的KOL智能推荐系统",
            "period": "2024.06-2025.07",
            "keywords": "【关键词】多链路召回、双塔模型、相似度排序、圈层分发、内容聚类、Feed流、社交图、联合推荐",
            "desc": "构建基于多维相似度的达人筛选与推荐引擎，打通内容聚类、语义召回、加权排序、圈层控制与预算调度全链路，支持多维召回、圈层策略、Feed流推荐与达人社交联合推荐。",
            "points": [
                "多链路召回与六维相似度融合：构建四路语义召回并扩展为六链路体系，实现基于达人内容、画像、商单与品类的语义建模与候选生成，召回命中率≥85%，实现召回层的结构化控制与多样性提升。",
                "最大中心度贪心迁移算法：优化达人在策略圈层中的排序分布，解决均摊策略导致的错位问题，提升策略一致性与优质达人分配率。",
                "Feed流推荐系统：支持达人间“自发现”推荐，结构为强匹配、延展、潜力、破圈四层，融合推荐理由、行为反馈与滚动加载，Feed点击率提升23%。",
                "联合智选——社交图驱动的联合推荐机制：基于达人互动关系构建社交网络，设计联合推荐策略，支持满足Nice值的亲近达人组合推荐，机制已覆盖超30%推荐任务场景。",
                "策略编排与结构优化引擎：打造基于圈层结构与目标感知的推荐策略引擎，支持召回强度、筛选阈值、圈层比例、达人迁移策略的动态配置与自动执行，实现推荐策略的“结构化编排”与“分发路径优化”；结合业务目标自适应调度，实现多营销场景下的主动推荐生成与可控策略闭环。目前已接入超20个游戏项目组流程。"
            ],
            "metric": "召回命中率 ≥85%，Feed 点击率提升 23%，联合推荐覆盖超 30% 任务场景，接入超 20 个游戏项目组。",
            "labels": []
        },
        {
            "title": "自动化数据分析管线",
            "period": "2023.03-2024.07",
            "keywords": "【关键词】LLM, ToolMaker, LATM, NvBench, Prompt Engineering, 数据安全",
            "desc": "构建大语言模型驱动的数据分析管线，将DA（数据分析）任务分解为数据读取、可视化生成与智能分析三阶段，支持面向自然语言的业务数据洞察、可视化与结构化分析输出。",
            "points": [
                "设计三阶段策略，引入多轮 Prompt 编排与结构化信息压缩方法，基于用户问题与数据库 schema 自动生成数据提取与处理代码。",
                "引入 LATM 框架，构建 ToolMaker / ToolUser 解耦结构。ToolMaker负责分析工具函数的自动构造与验证，ToolUser 负责函数组合与调用推理，实现通用数据分析能力的函数级封装与调度，推理成本整体下降逾 60%。",
                "构建私有化沙箱执行环境，在 code execution 阶段隔离敏感数据；洞察输出阶段引入指标扰动、数据混淆与不可逆脱敏策略，以确保业务数据在可控范围内被 LLM 消化。",
                "基于改造版 NvBench 数据集完成评估，分析能力在准确率与可读性等指标上与资深分析师持平，召回率提升 10.7%，可替代初级分析师工时超 70%。已实现多业务结构间的模板级自动适配。"
            ],
            "metric": "推理成本下降逾 60%；改造版 NvBench 评估中召回率提升 10.7%，可替代初级分析师工时超 70%。",
            "labels": []
        },
        {
            "title": "星瞳 text2motion 动作生成系统",
            "period": "2023.02-2024.07",
            "keywords": "【关键词】LLM, RAG, CLIP, MotionCLIP, Fantasia3D, SAM, 动作生成管线",
            "desc": "参与“星瞳”text2motion 系统的研发，构建自然语言驱动的角色动作生成流程，打通指令理解、动作检索、姿态合成与动画渲染全链路，支撑虚拟人内容生成能力建设。",
            "points": [
                "负责 LLM 指令解析模块开发，设计多轮 Prompt 编排策略，结合数据库 schema 与语义范式，将用户自然语言指令转化为结构化动作意图，驱动下游生成链路。",
                "参与实现动作检索链路，构建基于 CLIP / MotionCLIP 的语义动作 embedding 检索机制，实现语义层级的高精度动作片段匹配与动态组合；支持多语言与同义表达泛化。",
                "参与实现动作合成与姿态修正模块，基于 Fantasia3D、DragGAN 等生成模型完成角色动画构建，引入 SAM 自动分割人体区域用于动作目标区域定位，结合 DINO 自监督特征提取模型，进行骨骼关键点检测与跟踪，对连续动作帧执行姿态稳定性分析，自动识别并过滤骨骼跳变、肢体穿插等异常状态，有效提升动作序列的连贯性与物理合理性。",
                "支持中英双语文本驱动动作生成，主流动作生成成功率≥80%。已完成3次“直播3D回”的0bug运行。"
            ],
            "metric": "支持中英双语，主流动作生成成功率 ≥80%；完成 3 次“直播 3D 回”的 0 bug 运行。",
            "labels": []
        },
        {
            "title": "基于强化学习的碳中和政策模拟系统",
            "period": "2022.02-2022.06",
            "keywords": "【关键词】强化学习、因果推断、政策优化、奖励函数设计、因果图",
            "desc": "参与碳中和战略相关的政策模拟项目，基于历史能耗与排放数据，优化政府与企业的长期政策路径（如碳税、电价调控、科研资源分配）。",
            "points": [
                "独立设计马尔可夫决策过程（MDP）中的状态空间与动作空间，并且针对政策干预的延迟反馈特性，自主构造 reward shaping 策略：引入时间折现、分段阈值惩罚与社会成本加权，引导策略在碳排放下降与经济可持续间权衡，有效提升策略稳定性并避免短期激进解。",
                "搭建多策略对比实验框架，基于 DQN 与 PPO 在不同假设场景中完成策略训练与回放，最优策略在模拟环境下实现碳排放下降 18%、社会成本降低 12%。融合因果图建模与 do-calculus 推理，提升对策略行为背后变量因果关系的解释能力，策略波动性减少 21%。在此基础上完成可解释性因果输出，增强模型在跨部门最终研讨中的政策可接受性（7/8）。"
            ],
            "metric": "模拟环境最优策略：碳排放下降 18%、社会成本降低 12%、策略波动性减少 21%。",
            "labels": []
        }
    ],
    "wins": [
        {
            "id": "ccpc-changchun",
            "label": "CCPC 长春站（2020）",
            "medal": "铜牌",
            "emoji": "🥉",
            "color": "#cd7f32"
        },
        {
            "id": "ccpc-weihai",
            "label": "CCPC 威海站（2020）",
            "medal": "铜牌",
            "emoji": "🥉",
            "color": "#b87333"
        },
        {
            "id": "icpc-shanghai",
            "label": "ICPC 上海站（2020）",
            "medal": "铁牌",
            "emoji": "⚙️",
            "color": "#7f8c8d"
        },
        {
            "id": "icpc-jinan",
            "label": "ICPC 济南站（2020）",
            "medal": "银牌",
            "emoji": "🥈",
            "color": "#c0c0c0"
        }
    ]
};
